export default "__VITE_ASSET__fau3jNYQ__"